// Normal URLs (shop.eyantra.com/product/951) instead of the old #/ ones, the same way the retail
// Brandstore does it (brandstore-frontend App.hashToPath and retail/analytics.js). Both run once,
// before the app renders.

/** Old #/ links still work: emails, copied quote and shared-cart links, the AI assistant's cart
 *  links and the sign-in return (#/auth/callback?token=…) are all out in the world. Moves them to
 *  the normal address in the browser — no request is made, so nothing in the old hash is sent
 *  to a server. Query parameters from both sides of the # are kept. */
export function hashToPath() {
  const { hash, search } = window.location;
  if (!hash.startsWith('#/')) return;
  const [path, hashQuery = ''] = hash.slice(1).split('?');
  const params = new URLSearchParams(search);
  new URLSearchParams(hashQuery).forEach((value, key) => params.set(key, value));
  const query = params.toString();
  window.history.replaceState(null, '', path + (query ? `?${query}` : ''));
}

// Where a visit came from (ad tags and click ids), kept for the session so a later order can
// carry it, then taken out of the address bar so a copied link is just the page. Instagram's
// igshid, Google Shopping's srsltid and Google's cross-domain _gl are removed but not kept.
const SOURCE_KEY = 'sf_source';
const SOURCE_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'];
const STRIP_PARAMS = [...SOURCE_PARAMS, 'igshid', 'srsltid', '_gl'];

export function captureSourceAndClean() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = Object.fromEntries(SOURCE_PARAMS.filter(k => params.get(k)).map(k => [k, params.get(k)]));
    if (Object.keys(found).length) sessionStorage.setItem(SOURCE_KEY, JSON.stringify(found));
    else if (!sessionStorage.getItem(SOURCE_KEY) && document.referrer && !document.referrer.startsWith(window.location.origin)) {
      sessionStorage.setItem(SOURCE_KEY, JSON.stringify({ referrer: new URL(document.referrer).hostname }));
    }
    if (!STRIP_PARAMS.some(k => params.has(k))) return;
    STRIP_PARAMS.forEach(k => params.delete(k));
    const rest = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (rest ? `?${rest}` : '') + window.location.hash);
  } catch { /* storage blocked — the address stays as it was */ }
}

/** The visit's source ({ utm_source, … } or { referrer }), for attaching to an order. */
export function getSource() {
  try { return JSON.parse(sessionStorage.getItem(SOURCE_KEY)) || {}; } catch { return {}; }
}
